import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import { getProjectKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';

import { IdentityUserAri } from '@atlassian/ari/identity/user';

import { AnyAri } from '@atlassian/ari/any-ari';
import parameters from './__generated__/JswExpandableProjectQuery.graphql';
import refactoredParameters from './__generated__/JswExpandableProjectRefactoredQuery.graphql';

const NO_OF_BOARDS_TO_FETCH = 25;

export const nav4JSWProjectEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(): Promise<any> => {
			// Feature gate to choose between original and refactored implementation
			if (expVal('navx-1453-jsw-cmp-boards-dnd-2', 'isEnabled', false)) {
				return import(
					/* webpackChunkName: "nav4-jsw-project-entry-point-refactored" */ './JswExpandableProjectRefactoredQuery'
				);
			}
			return import(
				/* webpackChunkName: "nav4-jsw-project-entry-point" */ './JswExpandableProjectQuery'
			);
		},
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (params: EntryPointRouteParams) => {
		const cloudId = params.tenantContext?.cloudId ?? '';

		let projectKey = '';
		if (params.context?.match.params?.projectKey) {
			projectKey = params.context.match.params.projectKey;
		} else if (params.context?.match.params?.issueKey && fg('move-issue-view-to-entrypoint')) {
			projectKey = getProjectKey(params.context.match, params.context.query);
		}

		// Feature gate to choose between original and refactored GraphQL parameters
		const queryParameters = expVal('navx-1453-jsw-cmp-boards-dnd-2', 'isEnabled', false)
			? refactoredParameters
			: parameters;

		const entityAri = AnyAri.create({
			cloudId,
			resourceType: 'project',
			resourceId: projectKey,
			resourceOwner: 'jira',
		}).toString();
		const ownerAri = IdentityUserAri.create({
			userId: params.tenantContext.atlassianAccountId || 'UNKNOWN',
		}).toString();

		// Feature gate variables - original query doesn't have entityAri and ownerAri
		const variables = expVal('navx-1453-jsw-cmp-boards-dnd-2', 'isEnabled', false)
			? {
					cloudId,
					projectKey,
					noOfBoardsToFetch: NO_OF_BOARDS_TO_FETCH,
					entityAri,
					ownerAri,
				}
			: {
					cloudId,
					projectKey,
					noOfBoardsToFetch: NO_OF_BOARDS_TO_FETCH,
				};

		return {
			queries: {
				projects: {
					parameters: queryParameters,
					variables,
				},
			},
		};
	},
});
